// extracted by mini-css-extract-plugin
export default {"SignInSignUpLogo":"SiderContentC_SignInSignUpLogo__3HIRo","Menu":"SiderContentC_Menu__Htpa9"};